let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqPSz")).then(() => parcelRequire('ahOkj'));